import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Form Template",
    children: [
      {
        icon: "view-list",
        title: "List Form Template",
        to: {
          name: "form_template.list",
          query: { limit: 25, filter: "active" },
        },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Form Template",
        to: { name: "form_template.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
  {
    name: "Form Entry",
    children: [
      {
        icon: "view-list",
        title: "List Form Entry",
        to: { name: "form_entry.list", query: { limit: 10, filter: "all" } },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Form Entry",
        to: { name: "form_entry.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
];
